import React from "react";
import { Box, Typography, Card, CardContent, Button, Chip } from "@mui/material";
import styles from "./IndexPage.module.css";
import { useNavigate } from "react-router-dom"; 
import resources from "assets/images/resourcesPage.jpg";
import solutions from "assets/images/solutionsPage.jpg";
import wizard from "assets/images/wizardPage.jpg";
import { useTranslation } from "react-i18next";


const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate(); 

  const sections = [
    {
      id: "solutions",
      title: t("home.sections.solutions.title"),
      description: t("home.sections.solutions.description"),
      image: solutions,
      buttonText: t("home.sections.solutions.button"),
      color: "#00b894",
      route: "/solutions"
    },
    {
      id: "wizard",
      title: t("home.sections.wizard.title"),
      description: t("home.sections.wizard.description"),
      image: wizard,
      buttonText: t("home.sections.wizard.button"),
      color: "#00b894",
      route: "/wizard"
    },
    {
      id: "resources",
      title: t("home.sections.resources.title"),
      description: t("home.sections.resources.description"),
      image: resources,
      buttonText: t("home.sections.resources.button"),
      color: "#00b894",
      route: "/resources"
    }
  ];


  const handleNavigation = (route) => {
    navigate(route);
  };

  const features = t("home.features", { returnObjects: true });

  return (
    <Box className={styles.pageContainer}>
      {/* Hero Section */}
      <Box className={styles.heroSection}>
        <Box className={styles.heroContent}>
          <Typography variant="h2" className={styles.heroTitle}>
            {t("home.hero.title")}
            </Typography>

          <Typography variant="h6" className={styles.heroSubtitle}>
            {t("home.hero.subtitle")}
            </Typography>


          <Typography variant="h4" className={styles.heroTitle}>
            {t("home.goal.title")}
            </Typography>
            
            <Typography variant="h6" className={styles.heroSubtitle}>
              {t("home.goal.description")}
              </Typography>

          {/* <Box className={styles.featuresContainer}>
            {features.map((feature, index) => (
              <Chip
                key={index}
                label={feature}
                className={styles.featureChip}
                sx={{
                  animationDelay: `${index * 0.1}s`
                }}
              />
            ))}
          </Box> */}
        </Box>
      </Box>

      {/* Main Content Sections */}
      <Box className={styles.contentContainer}>
        {sections.map((section, index) => (
          <Card key={section.id} className={styles.sectionCard}>
            <Box className={styles.cardContent}>
              <Box className={styles.imageContainer}>
                <img
                  src={section.image}
                  alt={section.title}
                  className={styles.sectionImage}
                />
                <Box className={styles.imageOverlay} />
              </Box>
              <CardContent className={styles.textContent}>
                <Typography variant="h4" className={styles.sectionTitle}>
                  {section.title}
                </Typography>
                <Typography variant="body1" className={styles.sectionDescription}>
                  {section.description}
                </Typography>
                <Button
                  variant="contained"
                  className={styles.sectionButton}
                  onClick={() => handleNavigation(section.route)}
                  sx={{
                    backgroundColor: '#0fe880',
                    '&:hover': {
                      backgroundColor: section.color,
                      filter: 'brightness(0.9)',
                      transform: 'translateY(-2px)',
                    }
                  }}
                >
                  {section.buttonText}
                </Button>
              </CardContent>
            </Box>
          </Card>
        ))}
      </Box>

      {/* Bottom CTA Section */}
      <Box className={styles.ctaSection}>
        <Typography variant="h4" className={styles.ctaTitle}>
          {t("home.cta.title")}
          </Typography>
          
          <Typography variant="body2" className={styles.ctaDescription}>
            {t("home.cta.description")}
            </Typography>

      </Box>
    </Box>
  );
};

export default Home;